export default __webpack_public_path__ + "static/media/Insta Story.caafa94d.mp4";